export const ADD_AVAILABILITY_MESSAGE_TIMEOUT = 'ADD_AVAILABILITY_MESSAGE_TIMEOUT';